import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuoteBreakdownComponent } from './quote-breakdown/quote-breakdown.component'
import { MaterialModule } from '@app/shared/material.module'
import { PetQuoteDetailsComponent } from './pet-quote-details/pet-quote-details.component'
import { ReactiveFormsModule } from '@angular/forms'
import { OverlayModule } from '@angular/cdk/overlay'
import { PopoverDirective } from '../popover.directive'
import { PopoverTipComponent } from '@app/molecules/popover-tip/popover-tip.component'

@NgModule({
	declarations: [QuoteBreakdownComponent, PetQuoteDetailsComponent],
	imports: [
		CommonModule,
		MaterialModule,
		ReactiveFormsModule,
		OverlayModule,
		PopoverDirective,
		PopoverTipComponent,
	],
	exports: [QuoteBreakdownComponent, PetQuoteDetailsComponent],
})
export class QuoteBreakdownModule {}
